interface LogoMarkProps {
  size?: number;
  className?: string;
}

export function LogoMark({ size = 32, className = "" }: LogoMarkProps) {
  return (
    <span className={`relative inline-block ${className}`}>
      {/* Light theme: indigo gradient + white house */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="dark:hidden"
      >
        <rect width="32" height="32" rx="8" fill="url(#logo-grad-light)" />
        <path d="M16 6L26 14V26H20V20C20 19.2 19.2 18.5 18.5 18.5H13.5C12.8 18.5 12 19.2 12 20V26H6V14Z" fill="white" />
        <path d="M16 5L4 14L5.8 16.2L16 7.5L26.2 16.2L28 14Z" fill="white" />
        <circle cx="17" cy="22.5" r="1" fill="#6366f1" />
        <rect x="16.6" y="22.5" width="0.8" height="1.8" rx="0.4" fill="#6366f1" />
        <defs>
          <linearGradient id="logo-grad-light" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#818cf8" />
            <stop offset="1" stopColor="#4f46e5" />
          </linearGradient>
        </defs>
      </svg>
      {/* Dark theme: lighter gradient so it pops on dark bg */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="hidden dark:block"
      >
        <rect width="32" height="32" rx="8" fill="url(#logo-grad-dark)" />
        <path d="M16 6L26 14V26H20V20C20 19.2 19.2 18.5 18.5 18.5H13.5C12.8 18.5 12 19.2 12 20V26H6V14Z" fill="white" />
        <path d="M16 5L4 14L5.8 16.2L16 7.5L26.2 16.2L28 14Z" fill="white" />
        <circle cx="17" cy="22.5" r="1" fill="#a5b4fc" />
        <rect x="16.6" y="22.5" width="0.8" height="1.8" rx="0.4" fill="#a5b4fc" />
        <defs>
          <linearGradient id="logo-grad-dark" x1="0" y1="0" x2="32" y2="32" gradientUnits="userSpaceOnUse">
            <stop stopColor="#a5b4fc" />
            <stop offset="1" stopColor="#818cf8" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  );
}

interface LogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  showText?: boolean;
  className?: string;
}

const sizeMap = {
  sm: { icon: 28, text: "text-base" },
  md: { icon: 32, text: "text-lg" },
  lg: { icon: 40, text: "text-2xl" },
  xl: { icon: 72, text: "text-3xl" },
};

export function Logo({ size = "md", showText = true, className = "" }: LogoProps) {
  const { icon, text } = sizeMap[size];

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={icon} />
      {showText && (
        <span className={`${text} font-bold text-slate-900 dark:text-slate-100`}>
          Rent<span className="bg-gradient-to-r from-primary-600 to-primary-500 dark:from-primary-400 dark:to-primary-300 bg-clip-text text-transparent">Maadi</span>
        </span>
      )}
    </span>
  );
}
